module.exports = __webpack_public_path__ + "img/xtz.8c981a79.svg";